import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas de los Músculos Escalenos
// 10 Básicas + 10 Generales + 10 Complejas

export const escalenosQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10241,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántos músculos escalenos hay en total?",
    options: ["Dos", "Tres", "Cuatro", "Cinco"],
    correctAnswer: 2,
    explanation: "Hay tres músculos escalenos: anterior, medio y posterior. Todos se originan en las apófisis transversas de las vértebras cervicales y se insertan en las primeras dos costillas. Forman el 'escalón' lateral del cuello y son importantes músculos respiratorios accesorios."
  },
  
  {
    id: 10242,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina el escaleno anterior?",
    options: [
      "Apófisis transversas de C3-C6",
      "Apófisis transversas de C4-C6",
      "Apófisis transversas de C5-C7",
      "Apófisis transversas de C3-C7"
    ],
    correctAnswer: 0,
    explanation: "El escaleno anterior se origina en las apófisis transversas de las vértebras C3 a C6. Se inserta en la primera costilla, específicamente en el tubérculo del escaleno. Es el más medial de los tres escalenos."
  },
  
  {
    id: 10243,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la función principal de los escalenos en la respiración?",
    options: [
      "Exhalación forzada",
      "Inspiración forzada",
      "Elevación de las costillas",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "Los escalenos actúan como músculos respiratorios accesorios durante la inspiración forzada, elevando las primeras dos costillas. Son especialmente importantes cuando hay obstrucción de vías aéreas superiores o en pacientes con enfermedad pulmonar obstructiva crónica (EPOC)."
  },
  
  {
    id: 10244,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervios inervan a los músculos escalenos?",
    options: [
      "Ramos anteriores de C5-C8",
      "Ramos anteriores de C4-C7",
      "Plexo braquial",
      "Nervio frénico"
    ],
    correctAnswer: 0,
    explanation: "Los escalenos son inervados por los ramos anteriores de los nervios cervicales C5-C8. Estos nervios emergen del plexo braquial y proporcionan inervación motora a los escalenos, que son músculos prevertebrales importantes."
  },
  
  {
    id: 10245,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente a los escalenos?",
    options: [
      "Arteria vertebral",
      "Arteria carótida externa",
      "Arteria cervical ascendente",
      "Arteria tiroidea inferior"
    ],
    correctAnswer: 2,
    explanation: "La arteria cervical ascendente, rama de la arteria subclavia, irriga principalmente a los músculos escalenos. Esta arteria asciende por la fascia prevertebral y proporciona irrigación colateral importante para los músculos profundos del cuello."
  },
  
  {
    id: 10246,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura pasa entre el escaleno anterior y medio?",
    options: [
      "Arteria subclavia",
      "Nervio frénico",
      "Plexo braquial",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "Entre el escaleno anterior y medio pasan la arteria subclavia, el plexo braquial y el nervio frénico. Esta relación explica por qué las lesiones de los escalenos pueden afectar estructuras vasculonerviosas importantes del miembro superior."
  },
  
  {
    id: 10247,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué significa que los escalenos son músculos prevertebrales?",
    options: [
      "Se originan en vértebras",
      "Se insertan en vértebras",
      "Se localizan anteriores a las vértebras",
      "Forman parte de la columna vertebral"
    ],
    correctAnswer: 2,
    explanation: "Los escalenos son músculos prevertebrales porque se localizan anteriores a las vértebras cervicales, en el espacio prevertebral. Forman parte de los músculos profundos del cuello y contribuyen al soporte de la columna cervical."
  },
  
  {
    id: 10248,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se inserta el escaleno posterior?",
    options: [
      "Primera costilla",
      "Segunda costilla",
      "Tercera costilla",
      "Cabeza de la primera costilla"
    ],
    correctAnswer: 1,
    explanation: "El escaleno posterior se inserta en la segunda costilla, específicamente en su cara externa. Es el más lateral de los tres escalenos y contribuye menos a la elevación costal que los otros dos."
  },
  
  {
    id: 10249,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué acción realizan los escalenos sobre la columna cervical?",
    options: [
      "Flexión lateral",
      "Rotación",
      "Flexión anterior",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "Los escalenos actúan como flexores laterales, rotadores y flexores anteriores de la columna cervical. El escaleno anterior es el más potente flexor lateral, mientras que todos contribuyen a la flexión anterior durante movimientos cervicales."
  },
  
  {
    id: 10250,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué los escalenos son importantes en el síndrome del desfiladero torácico?",
    options: [
      "Forman el techo del desfiladero",
      "Comprimem estructuras vasculonerviosas",
      "Son puntos de inserción",
      "Contribuyen a la sintomatología"
    ],
    correctAnswer: 1,
    explanation: "Los escalenos contribuyen al síndrome del desfiladero torácico porque pueden comprimir las estructuras vasculonerviosas (arteria subclavia, vena subclavia y plexo braquial) que pasan entre ellos. La contractura o hipertrofia de los escalenos puede estrechar este espacio."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10251,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuyen los escalenos a la estabilidad cervical?",
    options: [
      "Como flexores principales",
      "Como estabilizadores laterales",
      "Como extensores",
      "Como rotadores principales"
    ],
    correctAnswer: 1,
    explanation: "Los escalenos actúan como estabilizadores laterales de la columna cervical durante movimientos de la cabeza. Su contracción tónica ayuda a mantener la alineación cervical y previene movimientos laterales excesivos, especialmente durante la marcha."
  },
  
  {
    id: 10252,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculo se encuentra posterior a los escalenos?",
    options: [
      "Longísimo del cuello",
      "Iliocostal cervical",
      "Multífidos cervicales",
      "Todos los anteriores"
    ],
    correctAnswer: 3,
    explanation: "Posteriores a los escalenos se encuentran los músculos erectores de la columna cervical: longísimo del cuello, iliocostal cervical y multífidos cervicales. Esta disposición en capas permite movimientos complejos y proporciona estabilidad a la columna cervical."
  },
  
  {
    id: 10253,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica irriga al escaleno anterior?",
    options: [
      "Arteria tiroidea inferior",
      "Arteria cervical ascendente",
      "Ramas directas de la subclavia",
      "Arteria vertebral"
    ],
    correctAnswer: 1,
    explanation: "La arteria cervical ascendente irriga específicamente al escaleno anterior. Esta arteria asciende entre el escaleno anterior y el largo del cuello, proporcionando irrigación a los músculos prevertebrales y contribuyendo a la anastomosis arterial del cuello."
  },
  
  {
    id: 10254,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se distribuye la inervación de los escalenos?",
    options: [
      "Cada escaleno por un nervio específico",
      "Escaleno anterior por C5-C6, otros por C7-C8",
      "Todos por ramos de C5-C7",
      "Inervación superpuesta de C4-C8"
    ],
    correctAnswer: 1,
    explanation: "El escaleno anterior recibe inervación de C5-C6, mientras que los escalenos medio y posterior son inervados por C7-C8. Esta distribución segmentaria explica por qué lesiones en diferentes niveles cervicales pueden afectar selectivamente ciertos escalenos."
  },
  
  {
    id: 10255,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común de los escalenos?",
    options: [
      "Escaleno mínimo",
      "Fusión entre escalenos",
      "Inserción doble en costillas",
      "Ausencia de escaleno posterior"
    ],
    correctAnswer: 0,
    explanation: "El escaleno mínimo (cabeza accesoria del escaleno anterior) es la variante más común, ocurriendo en 40-50% de la población. Se origina en C7 o primera costilla y puede comprimir el plexo braquial, causando síntomas de desfiladero torácico."
  },
  
  {
    id: 10256,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test clínico evalúa la contractura de los escalenos?",
    options: [
      "Test de Spurling",
      "Test de escalenos",
      "Test de Adson",
      "Test de Wright"
    ],
    correctAnswer: 2,
    explanation: "El test de Adson evalúa la contractura de los escalenos y su contribución al síndrome del desfiladero torácico. Consiste en rotación y extensión del cuello con inspiración profunda. La disminución del pulso radial sugiere compresión arterial subclavia."
  },
  
  {
    id: 10257,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué masa muscular embrionaria se desarrollan los escalenos?",
    options: [
      "Masa cervical lateral",
      "Masa hipomérica",
      "Masa prevertebral",
      "Masa occipital"
    ],
    correctAnswer: 1,
    explanation: "Los escalenos se desarrollan de la masa muscular hipomérica (hipáxial) del embrión, al igual que otros músculos prevertebrales. Esta masa da origen también a los músculos largos del cuello y contribuye a la formación de la musculatura cervical profunda."
  },
  
  {
    id: 10258,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tienen los escalenos?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "60% tipo I, 40% tipo II",
      "50% tipo I, 50% tipo II"
    ],
    correctAnswer: 2,
    explanation: "Los escalenos tienen predominio de fibras tipo I (60%), adaptadas para contracciones tónicas y posturales. Esto refleja su función como estabilizadores cervicales y músculos respiratorios accesorios que requieren resistencia más que potencia pura."
  },
  
  {
    id: 10259,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué fascia cubre a los escalenos?",
    options: [
      "Fascia cervical superficial",
      "Fascia prevertebral",
      "Fascia alar",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "Los escalenos están cubiertos por la fascia prevertebral, que los separa del espacio retrofaríngeo. Esta fascia es importante en infecciones profundas del cuello, ya que puede contener abscesos en el espacio prevertebral."
  },
  
  {
    id: 10260,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué los escalenos son importantes en la posición anatómica neutra?",
    options: [
      "Mantienen la lordosis cervical",
      "Previenen la cifosis cervical",
      "Estabilizan la columna",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "Los escalenos contribuyen al mantenimiento de la posición anatómica neutra al estabilizar la columna cervical, mantener la lordosis fisiológica y prevenir posturas defectuosas. Su tono muscular basal es importante para la alineación cervical."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10261,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con dolor de miembro superior y abolición del pulso radial al girar la cabeza. ¿Qué patología sugiere?",
    options: [
      "Síndrome del desfiladero torácico",
      "Compresión del plexo braquial",
      "Arteritis de la subclavia",
      "Trombosis venosa profunda"
    ],
    correctAnswer: 0,
    explanation: "La abolición del pulso radial al girar la cabeza (maniobra de Adson positiva) es diagnóstica de síndrome del desfiladero torácico causado por contractura de los escalenos. La compresión intermitente de la arteria subclavia entre escaleno anterior y medio explica los síntomas."
  },
  
  {
    id: 10262,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con tortícolis doloroso post-traumático cervical. EMG muestra espasmos de escalenos. ¿Qué complicación es?",
    options: [
      "Lesión de raíz nerviosa",
      "Espasmo muscular reflejo",
      "Fractura vertebral oculta",
      "Lesión ligamentosa"
    ],
    correctAnswer: 1,
    explanation: "Los espasmos reflejos de los escalenos son una complicación común post-traumática cervical. Se deben a irritación de raíces nerviosas o meninges, causando contractura protectora. La EMG confirma la actividad muscular anormal y ayuda a diferenciar de otras causas de tortícolis."
  },
  
  {
    id: 10263,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué procedimiento se realiza para tratar contractura refractaria de escalenos?",
    options: [
      "Liberación fascial",
      "Miectomía parcial",
      "Sección completa del músculo",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La miectomía parcial (resección segmentaria) de los escalenos se realiza para contractura refractaria en síndrome del desfiladero torácico. Se reseca específicamente el segmento causante de compresión, preservando la función muscular. Es más conservadora que la sección completa."
  },
  
  {
    id: 10264,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM cervical, ¿qué hallazgo confirma hipertrofia de escalenos?",
    options: [
      "Aumento del grosor muscular",
      "Disminución del espacio intermuscular",
      "Desplazamiento de estructuras vasculares",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La RM en hipertrofia de escalenos muestra aumento del grosor muscular, disminución del espacio entre escaleno anterior y medio, y desplazamiento medial de estructuras vasculonerviosas. Es útil para cuantificar la severidad del estrechamiento en desfiladero torácico."
  },
  
  {
    id: 10265,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar la sección quirúrgica de escalenos?",
    options: [
      "Parálisis diafragmática",
      "Lesión del plexo braquial",
      "Debilidad respiratoria",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La sección quirúrgica de escalenos puede causar lesión del plexo braquial por tracción o sección inadvertida de ramas nerviosas. Los nervios pasan entre escaleno anterior y medio. La complicación más grave es la pérdida funcional del miembro superior."
  },
  
  {
    id: 10266,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con EPOC severa presenta hipertrofia visible de escalenos. ¿Qué explica esto?",
    options: [
      "Compensación respiratoria",
      "Efecto de medicamentos",
      "Malnutrición",
      "Enfermedad neuromuscular"
    ],
    correctAnswer: 0,
    explanation: "La hipertrofia de escalenos en EPOC severa se debe a su uso compensatorio como músculos respiratorios accesorios. Los pacientes con obstrucción crónica usan los escalenos para aumentar el volumen torácico durante la inspiración. Es un signo clínico de insuficiencia respiratoria."
  },
  
  {
    id: 10267,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación EMG muestra actividad continua de escalenos en reposo. ¿Qué patología neuromuscular sugiere?",
    options: [
      "Miastenia gravis",
      "Esclerosis lateral amiotrófica",
      "Distrofia muscular",
      "Miopatía inflamatoria"
    ],
    correctAnswer: 1,
    explanation: "La actividad EMG continua de escalenos en reposo sugiere esclerosis lateral amiotrófica (ELA), donde hay fasciculaciones y actividad muscular anormal. Los escalenos son músculos accesibles para EMG cervical y pueden mostrar signos tempranos de enfermedad del motoneurona."
  },
  
  {
    id: 10268,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se utiliza para biopsia de escalenos?",
    options: [
      "Abordaje anterior del cuello",
      "Abordaje lateral sobre el borde posterior del esternocleidomastoideo",
      "Abordaje supraclavicular",
      "Abordaje posterior del cuello"
    ],
    correctAnswer: 1,
    explanation: "El abordaje lateral sobre el borde posterior del esternocleidomastoideo permite acceso directo a los escalenos. Es útil para biopsia en sospecha de miopatías inflamatorias o vasculitis. Evita estructuras vasculonerviosas importantes del triángulo carotídeo."
  },
  
  {
    id: 10269,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía cervical, ¿qué maniobra confirma contractura de escalenos?",
    options: [
      "Rotación pasiva del cuello",
      "Flexión lateral contra resistencia",
      "Palpación profunda durante inspiración",
      "Movimiento de deglución"
    ],
    correctAnswer: 2,
    explanation: "La ecografía durante palpación profunda y maniobra de inspiración forzada confirma contractura de escalenos. Muestra disminución de la elasticidad muscular normal y posible disminución del espacio intermuscular. Es útil para evaluar respuesta al tratamiento fisioterapéutico."
  },
  
  {
    id: 10270,
    muscle: 'escalenos',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Atleta con hipertrofia selectiva de escalenos. ¿Qué deporte explica esto?",
    options: [
      "Natación",
      "Ciclismo",
      "Remo",
      "Levantamiento de pesas"
    ],
    correctAnswer: 2,
    explanation: "Los remeros desarrollan hipertrofia selectiva de escalenos por el movimiento repetitivo de tracción durante la fase de recuperación. Los escalenos actúan como estabilizadores cervicales y contribuyen a la rotación del tronco. Esta hipertrofia es adaptativa pero puede causar dolor cervical."
  }
];
